export type BottomCardSlice = {
    readonly showMustCheckoutCard: boolean;
};

export const defaultBottomCardSlice: BottomCardSlice = {
    showMustCheckoutCard: true,
};
